<section class="user-migration-detail-page">
  <header class="user-migration-detail-header">
    <button mat-icon-button (click)="onCancel()" matTooltip="Volver al listado">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1>Migrar Usuario</h1>
      <p>Revisa y completa los datos antes de migrar el usuario</p>
    </div>
  </header>

  <!-- Loading State -->
  <div class="migration-detail-section" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    <p>Cargando datos...</p>
  </div>

  <!-- Two-Column Layout Container -->
  <div class="two-column-layout" *ngIf="!isLoading && legacyUser && filterData">
    <!-- Left Column: Legacy User Information -->
    <div class="layout-column layout-column-left">
      <div class="legacy-user-card">
        <!-- Email -->
        <div class="info-item">
          <mat-icon class="info-item-icon">email</mat-icon>
          <div class="info-item-content">
            <label>Email</label>
            <span class="info-item-value">{{ legacyUser.email }}</span>
          </div>
        </div>

        <!-- Nombre Completo -->
        <div class="info-item">
          <mat-icon class="info-item-icon">person</mat-icon>
          <div class="info-item-content">
            <label>Nombre</label>
            <span class="info-item-value">{{ legacyUser.firstName }} {{ legacyUser.lastName }}</span>
          </div>
        </div>

        <!-- Documento -->
        <div class="info-item" *ngIf="legacyUser.documentNumber">
          <mat-icon class="info-item-icon">badge</mat-icon>
          <div class="info-item-content">
            <label>Documento</label>
            <span class="info-item-value">{{ legacyUser.documentNumber }}</span>
          </div>
        </div>

        <!-- Unidad -->
        <div class="info-item" *ngIf="legacyUser.unitHierarchyInfo">
          <mat-icon class="info-item-icon">apartment</mat-icon>
          <div class="info-item-content">
            <label>Unidad</label>
            <div class="unit-info">
              <div class="unit-item" *ngIf="legacyUser.unitHierarchyInfo.mainUnit">
                <strong>{{ legacyUser.unitHierarchyInfo.mainUnit }}</strong>
              </div>
              <div class="unit-item small" *ngIf="legacyUser.unitHierarchyInfo.district">
                {{ legacyUser.unitHierarchyInfo.district }}
              </div>
              <div class="unit-item small" *ngIf="legacyUser.unitHierarchyInfo.area">
                {{ legacyUser.unitHierarchyInfo.area }}
              </div>
            </div>
          </div>
        </div>

        <!-- Roles Actuales -->
        <div class="info-item" *ngIf="legacyUser.isEditor || legacyUser.isValidator">
          <mat-icon class="info-item-icon">security</mat-icon>
          <div class="info-item-content">
            <label>Roles</label>
            <div class="roles-list">
              <div class="role-badge editor-badge" *ngIf="legacyUser.isEditor">
                <mat-icon>edit</mat-icon>
                <span>Editor</span>
              </div>
              <div class="role-badge validator-badge" *ngIf="legacyUser.isValidator">
                <mat-icon>check_circle</mat-icon>
                <span>Validador</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Accesos Actuales -->
        <div class="info-item" *ngIf="legacyUser.libraryAccesses && legacyUser.libraryAccesses.length > 0">
          <mat-icon class="info-item-icon">library_books</mat-icon>
          <div class="info-item-content">
            <label>Accesos</label>
            <div class="accesos-list">
              <span class="access-badge" *ngFor="let access of legacyUser.libraryAccesses">
                {{ access.id }} - {{ access.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right Column: Main Content Form -->
    <form [formGroup]="migrationForm" class="layout-column layout-column-right has-form-actions">
      <!-- Accordion with all collapsible sections -->
      <mat-accordion>
        <!-- 1. Personal Info Section -->
        <mat-expansion-panel #personalPanel class="expansion-section">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>badge</mat-icon>
              <span>Información personal</span>
              <mat-icon class="status-icon accent" *ngIf="isPersonalInfoValid">check_circle</mat-icon>
              <mat-icon class="status-icon warn" *ngIf="!isPersonalInfoValid && migrationForm?.touched">error</mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-grid form-single-column">
            <mat-form-field class="full-width">
              <mat-label>Nombre de usuario</mat-label>
              <input matInput formControlName="username" placeholder="Ingrese el nombre de usuario" />
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('username')?.valid && migrationForm?.get('username')?.touched"
                class="status-icon accent">check_circle</mat-icon>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('username')?.invalid && migrationForm?.get('username')?.touched"
                class="status-icon warn">error</mat-icon>
              <mat-error *ngIf="migrationForm?.get('username')?.hasError('required')">El nombre de usuario es
                obligatorio.</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" [readonly]="true" />
              <mat-icon matSuffix class="status-icon accent">check_circle</mat-icon>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="firstName" placeholder="Ingrese el nombre" />
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('firstName')?.valid && migrationForm?.get('firstName')?.touched"
                class="status-icon accent">check_circle</mat-icon>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('firstName')?.invalid && migrationForm?.get('firstName')?.touched"
                class="status-icon warn">error</mat-icon>
              <mat-error *ngIf="migrationForm?.get('firstName')?.hasError('required')">El nombre es
                obligatorio.</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Apellido</mat-label>
              <input matInput formControlName="lastName" placeholder="Ingrese el apellido" />
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('lastName')?.valid && migrationForm?.get('lastName')?.touched"
                class="status-icon accent">check_circle</mat-icon>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('lastName')?.invalid && migrationForm?.get('lastName')?.touched"
                class="status-icon warn">error</mat-icon>
              <mat-error *ngIf="migrationForm?.get('lastName')?.hasError('required')">El apellido es
                obligatorio.</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Tipo de documento</mat-label>
              <mat-select formControlName="documentType">
                <mat-option [value]="null">-- Seleccionar --</mat-option>
                <mat-option *ngFor="let doc of safeFilterData.documentTypes" [value]="doc.id">
                  {{ doc.name }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('documentType')?.valid && migrationForm?.get('documentType')?.touched"
                class="status-icon accent">check_circle</mat-icon>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('documentType')?.invalid && migrationForm?.get('documentType')?.touched"
                class="status-icon warn">error</mat-icon>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Número de documento</mat-label>
              <input matInput formControlName="documentNumber" placeholder="Ingrese el número de documento" />
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('documentNumber')?.valid && migrationForm?.get('documentNumber')?.touched"
                class="status-icon accent">check_circle</mat-icon>
              <mat-icon matSuffix
                *ngIf="migrationForm?.get('documentNumber')?.invalid && migrationForm?.get('documentNumber')?.touched"
                class="status-icon warn">error</mat-icon>
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <!-- 2. Church Membership Section -->
        <mat-expansion-panel #membershipPanel [formGroup]="institutionForm" class="expansion-section">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>church</mat-icon>
              <span>Pertenencia a la iglesia</span>
              <mat-icon class="status-icon accent" *ngIf="isChurchMembershipValid">check_circle</mat-icon>
              <mat-icon class="status-icon warn"
                *ngIf="!isChurchMembershipValid && institutionForm?.touched">error</mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-grid form-single-column">
            <!-- Community -->
            <div>
              <label class="section-label">Comunidad</label>
              <app-unit-selector formControlName="unit" label="Seleccionar Comunidad" [required]="true">
              </app-unit-selector>
            </div>

            <!-- Ministry, Appointments and Assignments (only shown if community is selected) -->
            <ng-container *ngIf="institutionForm?.get('unit')?.value">

              <!-- Ministry -->
              <div style="display: flex; gap: 12px; align-items: center; margin-bottom: 16px;">
                <mat-form-field style="flex: 1; min-width: 200px;">
                  <mat-label>Ministerio</mat-label>
                  <mat-select formControlName="ministry">
                    <mat-option [value]="null">-- Ninguno --</mat-option>
                    <mat-option *ngFor="let ministry of safeFilterData.ministries" [value]="ministry.id">
                      {{ ministry.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Ministry Unit (Optional) -->
                <app-optional-field [formControls]="institutionForm!.get('ministryUnit')"
                  triggerLabel="Activa en otra unidad" removeTooltip="Dejar sin asignar a otra unidad"
                  style="flex: 1; min-width: 200px;">
                  <app-unit-selector formControlName="ministryUnit" label="Unidad del Ministerio" [required]="false"
                    [showClearButton]="false">
                  </app-unit-selector>
                </app-optional-field>
              </div>

              <!-- Appointments -->
              <div>
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
                  <label class="section-label">Encargos</label>
                  <button type="button" mat-icon-button color="primary" (click)="addAppointment()"
                    matTooltip="Agregar encargo">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <div [formGroup]="institutionForm">
                  <div formArrayName="appointments" *ngIf="appointmentsArray!.length > 0">
                    <div *ngFor="let appointment of appointmentsArray!.controls; let i = index" [formGroupName]="i"
                      style="display: flex; gap: 12px; align-items: center; margin-bottom: 12px;">

                      <mat-form-field style="flex: 1; min-width: 200px;">
                        <mat-label>Encargo</mat-label>
                        <mat-select formControlName="appointmentId" [required]="true">
                          <mat-option [value]="null">-- Seleccionar --</mat-option>
                          <mat-option *ngFor="let appt of safeFilterData.appointments" [value]="appt.id">
                            {{ appt.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <app-optional-field [formControls]="appointment!.get('unitId')"
                        triggerLabel="Asignar a otra unidad" removeTooltip="Dejar sin asignar a otra unidad"
                        style="flex: 1; min-width: 200px;">
                        <app-unit-selector formControlName="unitId" label="Unidad del Encargo" [required]="false"
                          [showClearButton]="false">
                        </app-unit-selector>
                      </app-optional-field>

                      <button type="button" mat-icon-button color="warn" (click)="removeAppointment(i)"
                        matTooltip="Eliminar">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="!appointmentsArray || appointmentsArray!.length === 0" class="empty-state">
                    <mat-icon>info</mat-icon>
                    <p>No hay encargos registrados</p>
                  </div>

                </div>
              </div>

              <!-- Assignments -->
              <div>
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
                  <label class="section-label">Nombramientos</label>
                  <button type="button" mat-icon-button color="primary" (click)="addAssignment()"
                    matTooltip="Agregar nombramiento">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <div [formGroup]="institutionForm">
                  <div formArrayName="nominations" *ngIf="assignmentsArray!.length > 0">
                    <div *ngFor="let assignment of assignmentsArray!.controls; let i = index" [formGroupName]="i"
                      style="display: flex; gap: 12px; align-items: center; margin-bottom: 12px;">

                      <mat-form-field style="flex: 1; min-width: 200px;">
                        <mat-label>Nombramiento</mat-label>
                        <mat-select formControlName="nominationId" [required]="true">
                          <mat-option [value]="null">-- Seleccionar --</mat-option>
                          <mat-option *ngFor="let nom of safeFilterData.assignments" [value]="nom.id">
                            {{ nom.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <app-optional-field [formControls]="assignment!.get('unitId')"
                        triggerLabel="Asignar a otra unidad" removeTooltip="Dejar sin asignar a otra unidad"
                        style="flex: 1; min-width: 200px;">
                        <app-unit-selector formControlName="unitId" label="Unidad del Nombramiento" [required]="false"
                          [showClearButton]="false">
                        </app-unit-selector>
                      </app-optional-field>

                      <button type="button" mat-icon-button color="warn" (click)="removeAssignment(i)"
                        matTooltip="Eliminar">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="!assignmentsArray || assignmentsArray!.length === 0" class="empty-state">
                    <mat-icon>info</mat-icon>
                    <p>No hay nombramientos registrados</p>
                  </div>
                </div>
              </div>

            </ng-container>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </form>
  </div>

  <!-- Actions Footer -->
  <div class="migration-detail-footer">
    <span class="spacer"></span>
    <button mat-raised-button type="button" (click)="onCancel()" [disabled]="isMigrating">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onMigrate()"
      [disabled]="isMigrating">
      <mat-icon>cloud_upload</mat-icon>
      Migrar Usuario
    </button>
  </div>
</section>
